import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const partialMemberSignUpFailed = createSelector(membersState, (members) => members.signUpPartialMember.hasFailed);
